import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopInfo } from "../../selectors/selectCoopInfo";
import { selectOngoingPlayerProfileInfo } from "../../selectors/selectOngoingPlayerProfileInfo";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { ButtonDelete } from "../generic/common/ButtonDelete";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionCoopAssignMemberRole } from "./actionCoop";
import { IdCoopRole } from "./info-view/IdCoopRole";
var DialogDemoteLeaderConfirmDOM = function (_a) {
    var coopId = _a.coopId, playerId = _a.playerId, playerIdToAssign = _a.playerIdToAssign, onClose = _a.onClose, onConfirm = _a.onConfirm, playerName = _a.playerName;
    var replacements = new Map([[ReplacementLoca.zero_0, playerName]]);
    var message = utilLoca.get(IdLoca.confirmLeaderChange_desc, replacements);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.confirmLeaderChange_title, onClose: onClose, className: IdStyles.ModalBackgroundLanguageSelection },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: message }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonDelete, { onClick: onClose },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cancel })),
                React.createElement(ButtonPrimary, { onClick: function () {
                        return onConfirm(playerId, coopId, playerIdToAssign, IdCoopRole.Leader);
                    } },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.confirm }))))));
};
var mapState = function (state) {
    var onGoingPlayerProfile = selectOngoingPlayerProfileInfo(state);
    var id = onGoingPlayerProfile.id, name = onGoingPlayerProfile.name;
    var coop = selectCoopInfo(state);
    return {
        coopId: coop ? coop.id : undefined,
        playerId: selectPlayerInfo(state).playerId,
        playerIdToAssign: id,
        playerName: name,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.CoopDemoteLeaderConfirm)); },
    onConfirm: function (playerId, coopId, playerIdToAssign, roleId) {
        dispatch(actionCoopAssignMemberRole(playerId, coopId, playerIdToAssign, roleId));
        dispatch(actionModalClose(IdModal.CoopDemoteLeaderConfirm));
        dispatch(actionModalClose(IdModal.CoopRoleManagement));
    },
}); };
export var DialogDemoteLeaderConfirm = connect(mapState, mapDispatch)(DialogDemoteLeaderConfirmDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/DialogDemoteLeaderConfirm.tsx
// module id = 2568
// module chunks = 3